import axios from "axios";
import { config } from "../../config";
import {
  VacationRentalsAvailabilityResponse,
  VacationRentalsAvailabilityRequest,
} from "redmond";
import { vacationRentalsAvailabilityApi } from "../paths";

export const fetchVacationRentalsAvailability = (
  body: VacationRentalsAvailabilityRequest
): Promise<VacationRentalsAvailabilityResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(vacationRentalsAvailabilityApi, body, {
        baseURL: config.baseURL,
      });
      const { value } = res.data;
      resolve(value);
    } catch (e) {
      reject(e);
    }
  });
